export const SET_ORGANISATION_DETAILS = (state, payload) => {
    state.organisationDetails = payload;
};

export const SET_ORGANISATION_ASSET = (state, payload) => {
    state.organisationAsset = payload;
};

export const SET_PIN = (state, payload) => {
    state.pin = payload;
};

export const SET_CURRENCY = (state, payload) => {
    state.currency = payload;
};

export const SET_FUND_METHOD = (state, payload) => {
    state.fundMethod = payload;
};

export const SET_MINIMUM_WITHDRAWAL = (state, payload) => {
    state.minimumWithdrawal = payload;
};

export const SET_EXCHANGE_RATE = (state, payload) => {
    state.exchangeRate = payload;
};

export const SET_WITHDRAW_METHOD = (state, payload) => {
    state.withdrawMethod = payload;
};

export const SET_CASH_BALANCE = (state, payload) => {
    state.walletBalance = payload;
};

export const SET_TRADE_BALANCE = (state, payload) => {
    state.tradeBalance = payload;
};

export const SET_NOTIFICATION_COUNT = (state, payload) => {
    state.notificationCount = payload;
};

export const SET_VIRTUAL_ACCOUNT = (state, payload) => {
    state.virtualAccount = payload;
};

export const SET_ORG_TRANSACTIONS = (state, payload) => {
    state.transactions = payload;
};

export const SET_TRANSACTION_INFO = (state, payload) => {
    state.TransactionPageInfo = payload;
};

export const SET_ENTITY_CARD = (state, payload) => {
    state.entityCard = payload;
};

export const SET_WALLET_TRANSACTION = (state, payload) => {
    state.walletTransactions = payload;
};

export const SET_WALLET_TRANSACTION_PAGE = (state, payload) => {
    state.walletPage = payload;
};

export const SET_WALLET_TRANSACTION_PAGES = (state, payload) => {
    state.walletPages = payload;
};

export const SET_FEATURES = (state, payload) => {
    state.features = payload;
};
export const SET_ORG_TOKENS = (state, payload) => {
    state.tokens = payload;
};
export const SET_UPDATES = (state, payload) => {
    state.updates = payload;
};

export const SET_UPDATE_PAGE = (state, payload) => {
    state.updatePage = payload;
};

export const SET_UPDATE_PAGES = (state, payload) => {
    state.updatePages = payload;
};
export const SET_TRANSACTION_FEES = (state, payload) => {
    state.transactionFees = payload;
};
export const SET_LAST_RAISE_STAGE = (state, stage) => {
    state.lastRaiseStage = stage;
};
export const SET_CURRENCY_WALLETS = (state, wallets) => {
    state.currencyWallets = wallets;
};

export const SET_WALLET_BALANCE = (state, balance) => {
    state.walletBalance = balance;
};

export const SET_MINIMUM_DEPOSIT = (state, payload) => {
    state.minimumDeposit = payload;
}

export const SET_CURRENCY_RATE = (state, balances) => {
    state.currencyRate = balances;
};

export const SET_INVESTMENT_CATEGORIES = (state, payload) => {
    state.investmentCategories = payload;
};

export const SET_LOANS = (state, payload) => {
    state.loans = payload;
};

export const SET_BORROWERS = (state, payload) => {
    state.borrowers = payload;
};

export const SET_LOAN_SUMMARY = (state, payload) => {
    state.loanSummary = payload;
};

export const SET_CREDIT_CURRENCY = (state, payload) => {
    state.creditCurrency = payload;
};

export const SET_LOAN_CONFIGURATION = (state, payload) => {
    state.loanConfiguration = payload;
};

export const SET_CODE = (state, payload) => {
    state.code = payload;
};

export const SET_CODE_TYPE = (state, payload) => {
    state.codeType = payload;
};

export const SET_PAGE = (state, payload) => {
    state.creditPage = payload;
};

export const SET_PAGES = (state, payload) => {
    state.creditPages = payload;
};

export const SET_B_PAGE = (state, payload) => {
    state.borrowerPage = payload;
};

export const SET_B_PAGES = (state, payload) => {
    state.borrowerPages = payload;
};

export const SET_ROLES = (state, payload) => {
    state.iamGroups = payload;
};

export const SET_IAMGROUPS_WITH_MEMBERS = (state, groupsWithMembers) => {
    state.iamGroups = {
        ...state.iamGroups,
        docs: groupsWithMembers
    };
}

export const REMOVE_TEAM_MEMBER = (state, payload) => {
    const role = state.iamGroups.find(r => r.id === payload.roleId);
    if (role && role.teamMembers) {
        role.teamMembers = role.teamMembers.filter(member => member.id !== payload.memberId);
    }
}

export const SET_TEAM_MEMBER = (state, member) => {
    state.teamMember = member;
};

export const SET_TEAM_MEMBERS = (state, teamMembers) => {
    state.teamMembers = teamMembers;
};


